import React from 'react';
import ContentCard from 'components/global/content-card';
import {
  Area,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  TooltipProps,
  XAxis,
  YAxis,
} from 'recharts';
import { AreaChart } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import TooltipValueOutput from 'components/global/outputs/TooltipValueOutput';
import PercentageOutput from 'components/global/outputs/PercentageOutput';
import moment from 'moment';
import { getDates } from 'pages/dashboard/data';
// import { data } from './data';

interface ChartProps {
  data: any[];
}

const ProtocolOwned: React.FunctionComponent<ChartProps> = ({ data }) => {
  const chartData: any[] = [];
  data.forEach(line => {
    const time = moment(line.timestamp * 1000).format('MMM DD');
    chartData.unshift({
      date: time,
      LPTreasury: line.treasuryMonkDaiPOL,
    });
  });

  const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>) => {
    if (active && payload && payload.length) {
      const value = Number(payload[0].value)
        .toString()
        ?.match(/^-?\d+(?:\.\d{0,2})?/);
      return (
        <div
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: 'white',
            border: 'none',
            borderRadius: 10,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly',
            alignItems: 'flex-start',
            padding: 15,
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              marginBottom: 5,
            }}
          >
            <TooltipValueOutput color="green" value={payload[0].dataKey?.toString() || '--'} />
            <PercentageOutput value={value ? value[0] : '0'} />
          </div>
          <p style={{ padding: 0, margin: 0, marginTop: 10 }}>{label}</p>
        </div>
      );
    }

    return null;
  };

  const headerValue = Number(data[0].treasuryMonkDaiPOL)
    .toString()
    ?.match(/^-?\d+(?:\.\d{0,2})?/);
  const days = getDates(data);

  return (
    <ContentCard title="Protocol Owned Liquidity Monk-DAI" maxWidth={false}>
      <p className="chart-title-value">{headerValue ? headerValue[0] : '0'}% Today</p>
      <ResponsiveContainer width="100%" height={350}>
        <AreaChart data={chartData} margin={{ top: 10, right: 0, left: -10, bottom: 0 }}>
          <defs>
            <linearGradient id="LPTreasury" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="green" stopOpacity={0.8} />
              <stop offset="95%" stopColor="green" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="date"
            style={{ stroke: '#ffffff' }}
            tickLine={false}
            strokeWidth={2}
            tick={{
              strokeWidth: 1,
              fontWeight: 100,
            }}
            ticks={days}
          />
          <YAxis
            style={{ stroke: '#ffffff', fontWeight: 100 }}
            axisLine={false}
            tickLine={false}
            tickFormatter={value => `${value}%`}
          />
          <CartesianGrid strokeDasharray="2" vertical={false} style={{ opacity: 0.2 }} />
          <Tooltip content={<CustomTooltip />} />

          <Area
            type="natural"
            dataKey="LPTreasury"
            stroke="none"
            fillOpacity={1}
            fill="url(#LPTreasury)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </ContentCard>
  );
};
export default ProtocolOwned;
